module.exports = __webpack_public_path__ + "placa_td_loja_s_juros_0x12_catao.png?2237200b59eb0bb92f3a7bcab7214c2c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_td_loja_s_juros_0x12_catao.png
// module id = 132
// module chunks = 0